'use client';

import { useKPIThresholdAlerts } from '@/lib/hooks/useKPIThresholdAlerts';

/**
 * KPIAlertLayer
 *
 * Thin client component that activates KPI threshold monitoring.
 * Renders nothing — side-effects only (toast alerts).
 * Mount once in the root layout inside AuthProvider.
 */
export default function KPIAlertLayer() {
  useKPIThresholdAlerts();
  return null;
}
